<template>
    <div class="check">
        <div class="bgBlueF3 px-38 pb-30 mb-30">
            <p>{{p[0]}}</p>
            <div class="noIndent">
                <p v-for="(item,index) in p.slice(1)" :key="index">{{item}}</p>
            </div>
        </div>

        <div class="px-38 refer">
            <span>参考资料：《医学影像检查技术》 主编：李萌 樊先茂 出版社：人民卫生出版社 标准书号：ISBN  978-7-117-18930-9</span>
            <span>参考资料：《医学影像检查技术学》    主编：余建明 曾勇明      出版社：人民卫生出版社         标准书号：ISBN  978-7-117-22940-1/R·22941</span>
            <span>参考资料：《医学影像检查技术 》       主编：雷子乔 郑艳芬      出版社：人民卫生出版社          标准书号：ISBN  978-117-30508-8  等</span>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            p:['医影智能医学影像检查技术虚拟仿真实训系统包含：DR检查技术虚拟仿真实训系统、CT检查技术虚拟仿真实训系统和MRI检查技术虚拟仿真实训系统。',
            '虚拟仿真实训教学目标：',
            '① 掌握各种医学影像检查技术基础理论知识，并能联系实际、综合应用各种检查技术；',
            '② 掌握各部位X线常规体位摄影技术及临床应用；',
            '③ 掌握各部位CT检查技术成像参数、后处理技术及临床应用；']
        }
    }
}
</script>

<style lang="scss" scoped>
.check{
   .noIndent{
       p{
           text-indent: 0;
       }
   } 
}
</style>